module.exports = __webpack_public_path__ + "img/base_white.e5c36655.jpg";